import { render, staticRenderFns } from "./profile-subscriptions.vue?vue&type=template&id=6a8c6408&scoped=true&"
import script from "./profile-subscriptions.ts?vue&type=script&lang=ts&"
export * from "./profile-subscriptions.ts?vue&type=script&lang=ts&"
import style0 from "./profile-subscriptions.scss?vue&type=style&index=0&id=6a8c6408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c6408",
  null
  
)

export default component.exports